<template>
  <splitpanes class="default-theme">

    <pane min-size="15" size="20">
      <div v-if="isDcManager" class="card-header" style="width: 100%;border: solid 1px lightgrey">
        <div v-for="item in folderButton" :key="item.id" class="folderButton">
          <FrameButton :key="item.id" :button="item" :parentData="currentFolder"></FrameButton>
        </div>
        <el-icon :size="24" @click="refreshNode(currentFolder.id)" style="margin-top: 5px">
          <ElIconRefresh class="el-icon-refresh"/>
        </el-icon>
      </div>

      <el-tree
          ref="tree"
          :data="folderData"
          :props="defaultProps"
          node-key="id"
          :load="loadNode"
          lazy
          @node-click="nodeClickHandle"
          highlight-current
          :expand-on-click-node="false"
          min-height="500px"
          style="height: 100%;overflow: auto"
      >
      </el-tree>
    </pane>

    <pane min-size="50">
      <div class="card-header" style="width: 100%;padding: 3px;border: solid 1px lightgrey">
        <el-row style="width: 100%">
          <el-col :span="20">
            <span width="100%" class="department-name">{{ currentFolder.full_path }}</span>
            <span class="file-count">【{{ totalCnt }}】</span>
          </el-col>

          <el-col :span="4" align="right" style="display: flex;align-items: center;justify-content: flex-end;">
            <el-popover :width="450" style="border: 1px solid lightgrey">
              <template #reference>
                <el-icon :size="22" style="margin-left: 5px">
                  <ElIconFilter class="el-icon-filter" :color="searchData.hasCondition==true?'blue':'#333333'"/>
                </el-icon>
              </template>

              <template #default>
                <el-form :model="searchData" label-width="90px" style="max-width: 450px">
                  <el-form-item label="含子目录">
                    <el-switch v-model="searchData.searchSub" @change="setHasCondition"/>
                  </el-form-item>
                  <el-form-item label="文件名">
                    <el-input v-model="searchData.fileName" style="width: 240px" @change="setHasCondition"/>
                  </el-form-item>

                  <el-form-item label="更新日期">
                    <el-radio-group v-model="searchData.updateDateRange" @change="setHasCondition">
                      <el-radio-button value="date_range_0_3">3天内</el-radio-button>
                      <el-radio-button value="date_range_0_7">一周内</el-radio-button>
                      <el-radio-button value="date_range_0_30">一月内</el-radio-button>
                      <el-radio-button value="date_range_31_36500">一月以上</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label=" ">
                    <el-button type="primary" @click="searchBtn">检索</el-button>
                    <el-button type="primary" @click="clearCondition">清除条件</el-button>
                  </el-form-item>
                </el-form>
              </template>
            </el-popover>

            <el-popover :width="260" style="border: 1px solid lightgrey">
              <template #reference>
                <el-icon :size="22" style="margin-left: 5px">
                  <ElIconSort class="el-icon-sort" :color="(searchData.searchOrder != 'name')?'blue':'#333333'"/>
                </el-icon>
              </template>
              <template #default>
                <el-form :model="searchData" label-width="90" style="max-width: 300px">
                  <el-radio-group v-model="searchData.searchOrder" @change="searchBtn">
                    <el-form-item label="文件名称">
                      <el-radio-button value="name">升序</el-radio-button>
                      <el-radio-button value="name desc">降序</el-radio-button>
                    </el-form-item>
                    <el-form-item label="创建时间">
                      <el-radio-button value="create_time">升序</el-radio-button>
                      <el-radio-button value="create_time desc">降序</el-radio-button>
                    </el-form-item>
                    <el-form-item label="更新时间">
                      <el-radio-button value="update_time">升序</el-radio-button>
                      <el-radio-button value="update_time desc">降序</el-radio-button>
                    </el-form-item>
                  </el-radio-group>
                </el-form>
              </template>
            </el-popover>

            <el-icon v-if="viewType=='grid'" :size="22" @click="viewType='card'" style="margin-left: 5px">
              <ElIconGrid class="el-icon-grid" color="#333333"/>
            </el-icon>
            <el-icon v-if="viewType=='card'" :size="22" @click="viewType='grid'" style="margin-left: 5px">
              <ElIconPostcard class="el-icon-postcard" color="#333333"/>
            </el-icon>
            <FrameButton v-if="isDcManager" :parentData="currentFolder" :button="uploadButton"></FrameButton>
          </el-col>
        </el-row>
      </div>

      <div v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0, 0, 0, 0.5)"
           :style="docList.length > 0 ? 'height: 89%' : 'height: 95%'" style="background-color: white; overflow-y: auto">
        <div v-if="viewType=='card'" class="doc-box">
          <DocCard v-for="(element,index) in docList" :key="index" :doc-data="element" :is-dc-manager="isDcManager"/>
        </div>

        <div v-if="viewType=='grid'" class="doc-box">
          <el-table :data="docList" stripe style="width: 100%">
            <el-table-column prop="name" label="文件名" min-width="300"/>
            <el-table-column prop="file_size" label="文件大小" width="120"/>
            <el-table-column prop="update_time" label="更新时间" width="180"/>
            <el-table-column prop="update_user_name" label="更新人" width="180"/>
            <el-table-column align="center" label="操作" width="100">
              <template #default="scope">
                <el-button type="text" @click="openPage(scope.row)" size="small">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-show="docList.length > 0" style="background-color: white;border-top: solid 1px lightgrey;padding: 3px;height: 40px;width: 100%;display: flex;justify-content:flex-end;">
        <el-pagination :current-page="searchData.pageNum" :page-size="searchData.pageSize" :page-sizes="[50, 100, 200, 500]"
                       background layout="sizes, prev, pager, next" :total="totalCnt"
                       @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
      </div>
    </pane>

  </splitpanes>
</template>

<script>

import DocCard from "./DocCard";
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "DocCenter",
  components: {DocCard, Splitpanes, Pane},
  data() {
    return {
      uploadButton: {
        "component": "button",
        "type": "text",
        "icon": "el-icon-upload",
        "style": "font-size: 22px",
        "icon_only": true,
        "click": "jsOpenWindow",
        "click_success": ["jsRefreshForm"],
        "window": {"component": "frame/FrameForm", "type": "dc_doc_add", "title": "上传文件", "width": 800, "height": 600}
      },
      folderButton: [
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-folder-add",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "dc_dir_add", "title": "添加子目录", "width": 500, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-edit",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "dc_dir_edit", "title": "修改目录", "width": 500, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-TopRight",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "dc_dir_move", "title": "移动目录和文件", "width": 600, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-delete",
          "icon_only": true,
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "dc_dir_del", "title": "删除目录", "width": 600, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon_only": true,
          "icon": "el-icon-setting",
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "dc_dir_setting", "title": "目录设置", "width": 850, "height": 600, "icon": "system/tools"}
        }
      ],
      orderItems: [{"name": "文件名称升序", "value": "name_asc"}, {"name": "文件名称降序", "value": "name_desc"}, {"name": "创建时间升序", "value": "create_time"}, {
        "name": "创建时间降序",
        "value": "-create_time"
      }, {"name": "修改时间升序", "value": "update_time"}, {"name": "修改时间降序", "value": "-update_time"}, {"name": "文件大小升序", "value": "file_size"}, {
        "name": "文件大小降序",
        "value": "-file_size"
      }],
      addData: {parentId: '', name: ''},
      searchData: {hasCondition: false, fileName: '', searchSub: false, searchOrder: 'name', fileTypes: [], fileStatus: '', updateDateRange: '', pageSize: 50, pageNum: 1},
      viewType: 'card',
      folderData: [],
      currentFolder: {},
      subPage: 'user',
      showEditDepartment: false,
      editData: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      docList: [],
      totalCnt: 0,
      loading: false,
      isDcManager: false
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          // 刷新当前节点
          this.refreshNode(this.currentFolder.id);
        },
        reloadParentNode: () => {
          //刷新父节点
          console.log("reloadParentNode,parent_id:" + this.currentFolder.parent_id)
          this.refreshNode(this.currentFolder.parent_id);
        },
        searchDoc: () => {
          //查询
          console.log("searchDoc,dir_id:" + this.currentFolder.id)
          this.searchDoc();
        }
      }
    }
  },
  methods: {
    openPage(row) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "oa/FileViewerWithVersions";
      windowObj.name = "文档查看";
      windowObj.parentData = row;
      windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.no_min = true
      windowObj.max = true

      this.$store.dispatch('core/openWindow', windowObj)
    },
    handleSizeChange(size) {
      this.searchData.pageSize = size
      this.searchDoc();
    },
    handleCurrentChange(pageNo) {
      this.searchData.pageNum = pageNo
      this.searchDoc();
    },
    refreshNode(nodeId) {
      if (nodeId && nodeId.length > 0) {
        this.$refs.tree.store.nodesMap[this.currentFolder.id].loaded = false;
        this.$refs.tree.store.nodesMap[this.currentFolder.id].loadData();
      } else {
        this.loadDirTree()
      }
    },
    //--勾选--
    nodeClickHandle(currentRow) {
      this.currentFolder = currentRow
      this.currentPage = 1
      this.searchDoc();
    },
    async loadDirTree() {
      let data = await this.$http('dirService.getChildren', {parent_id: ''})
      this.folderData = data;
    },
    async loadNode(node, resolve) {
      console.log("node.id=" + node.data.id);
      let data = await this.$http('dirService.getChildren', {parent_id: node.data.id})
      resolve(data)
    },
    async searchBtn() {
      this.searchData.pageNum = 1
      this.searchDoc();
    },
    async searchDoc() {
      this.searchData.dirId = this.currentFolder.id
      this.loading = true;
      this.$http('docService.searchDoc', this.searchData, false).then(data => {
        this.loading = false;
        this.docList = data.records
        this.totalCnt = data.total
      }, errMsg => {
        this.loading = false;
        return this.$message.error(errMsg);
      })

      if (this.docList.length > 500) {
        this.$message.warning("检索结果达到上限【500】，建议进行更精确的检索");
      }
    },
    clearCondition() {
      this.searchData.hasCondition = false;
      this.searchData.searchSub = false;
      this.searchData.fileName = '';
      this.searchData.searchOrder = '';
      this.searchData.fileStatus = '';
      this.searchData.updateDateRange = '';
      this.searchData.fileTypes = []
      this.searchDoc();
    },
    setHasCondition() {
      if (this.searchData.searchSub == true) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.fileName.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.fileStatus.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.fileTypes.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.updateDateRange.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      this.searchData.hasCondition = false;
      return
    }
  },
  async created() {
    this.isDcManager = await this.$http('dirService.isDcManager')
  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.folderButton {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.doc-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  min-height: 600px;
}

.doc-card {
  width: 150px;
  height: 210px;
  margin: 10px;
  border: 1px solid gainsboro;
  border-radius: 10px;
}

.doc-card:hover {
  background-color: #E5F3FF;
}

.file-count {
  color: #409EFF;
  font-size: large;
  margin-left: 5px;
}

.pdf {
  background-image: url("../../../../public/icon/filetype/pdf.png");
}

.excel {
  background-image: url("../../../../public/icon/filetype/excel.png");
}

.word {
  background-image: url("../../../../public/icon/filetype/word.png");
}

.ppt {
  background-image: url("../../../../public/icon/filetype/ppt.png");
}

.png {
  background-image: url("../../../../public/icon/filetype/jpg.png");
}

.file {
  background-image: url("../../../../public/icon/filetype/file.png");
}

.icon {
  width: 100px;
  height: 100px;
  background-size: 100px 100px;
  margin-left: 25px;
}

.doc-name {
  font-size: 16px;
  width: 100%;
  height: 33px;
  margin-top: 10px;
  margin-bottom: 10px;
  //word-wrap: normal;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  line-height: 16px;
  padding-left: 10px;
  text-align: center;
}

.doc-version {
  margin-left: 10px;
  font-size: 20px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-author {
  font-size: 16px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-time {
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.doc-status {
  font-size: 12px;
  width: 100%;
}

.doc-menu {
  font-size: 14px;
  margin: 5px 0 0 5px;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}

</style>
